
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RevisionCommonData } from "@/types/revisions";

@Component({})
export default class RevisionItem extends Vue {
  @Prop({
    default() {
      return {};
    }
  })
  revision!: RevisionCommonData;

  @Prop({ default: false })
  selected!: boolean;
}
